import axios from 'axios'
import store from '../store' // your vuex store
//import swal from 'sweetalert2'

let ifAuthenticated = (to, from, next) => {
  let formData = new FormData()
  formData.append('log_uuid', window.localStorage.getItem('log_uuid'))
  axios.post('/auth/refresh', formData).then(res => {
    if (res.data.status == 'success') {
      store.state.authToken = res.data.token
      store.state.authUser = res.data.user
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token
      /* let pathArry = to.fullPath.split('/')
            if (pathArry[1] != store.state.authUser.roleSlug) {
                next(store.state.authUser.roleSlug)
                return
            } */
      next()
      return
    } else {
      next('/login')
      alert(res.data.message)
      return
    }
  })
}

let ifNotAuthenticated = (to, from, next) => {
  let authToken = store.state.authToken
  if (authToken == '' || authToken == null || authToken == undefined) {
    next()
    return
  }
  /* console.log("logout clicked");
    axios.post("/refresh-auth-user").then(res => {
        if (res.data.status == "success") {
            store.state.authToken = res.data.token
            store.state.authUser = res.data.user
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data.token;
            next(store.state.authUser.roleSlug)
            return
        } else {
            next()
            return
        }
    }) */
  next(store.state.authUser.roleSlug)
}

//const tokenKey = 'cg_54d4ab3b3207532'

/*let ifAuthenticated = (to, from, next) => {
    let storage = window.localStorage.getItem(tokenKey)
    if (storage == null || storage == '' || storage == undefined) {
        store.state.authUser = {};
        window.localStorage.removeItem(tokenKey);
        next('/login')
        return
    }
    let user = JSON.parse(crypt.decryptWithAES(window.localStorage.getItem(tokenKey)));
    let currTimestamp = Math.floor(Date.now() / 1000)

    if (currTimestamp > parseInt(user.expiredAt)) {
        store.state.authUser = {};
        window.localStorage.removeItem(tokenKey);
        alert("Your session expired.")
        //swal.fire("Oops!", "Your session expired.", "info");
        window.location.replace(window.location.origin + '')
        return
    }
    store.state.authUser = user
    axios.defaults.headers.common['AuthToken'] = user.token;

    let pathArry = to.fullPath.split('/')
    if (pathArry[1] != user.roleSlug) {
        next(user.roleSlug)
        return
    }
    next();
}
*/

/* let ifNotAuthenticated = (to, from, next) => {
    let storage = window.localStorage.getItem(tokenKey)
    if (storage == null || storage == '' || storage == undefined) {
        next()
        return
    }
    let user = JSON.parse(crypt.decryptWithAES(window.localStorage.getItem(tokenKey)));

    next(user.roleSlug)
} */

export default {
  ifAuthenticated,
  ifNotAuthenticated
}
